import React from "react"
import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { CarouselSection } from "../../../CarouselSection"
import { SalasMultimediaImg } from "../../../CarouselImages/SalasMultimediaImg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import logoSalasMultimediaTouch from "../../../../images/soluciones/salas-multimedia/Touch_Screen_blanco.svg"
import "./info.scss"

export const InfoSection = ({ classTitle, mainTitle }) => {
  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={mainTitle.toUpperCase()}
          cNameSolucion={classTitle}
        />
        <div
          className={`info-${classTitle}-detalles-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className={`info-${classTitle}-detalles-text-descripcion`}>
            <h5>
              En <span>Skol Solutions </span>
              tenemos todas las soluciones para entregarle su sala multimedia
              “llave en mano”. Ofrecemos varias opciones de acuerdo al tamaño de
              la sala, al uso que se le vaya a dar, a la capacidad, entre otros.
            </h5>
          </div>
          <div className={`info-${classTitle}-detalles-text`}>
            <div className={`info-${classTitle}-detalles-text-equip-title`}>
              <h6>Equipamiento que integramos:</h6>
            </div>
            <div className={`info-${classTitle}-detalles-text-equip-container`}>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Videoconferencia</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Proyector</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Displays de grado comercial</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Sonorización</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Luminarias</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Pantallas</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Video-wall</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Mobiliario profesional Videoconferencias</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Dispositivos de colaboración</span>
              </div>
              <div className="equip-item-container">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Accesorios para cables</span>
              </div>
            </div>
          </div>
          <CarouselSection
            classTitle={classTitle}
            images={SalasMultimediaImg}
            cover={true}
            s1920="530px"
            s1366="490px"
            s1024="327px"
            s768="228px"
            s640="228px"
            s360="192px"
          />
        </div>
        <div
          className={`info-${classTitle}-touch-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className={`info-${classTitle}-touch-logo`}>
            <img
              src={logoSalasMultimediaTouch}
              alt={`${classTitle} touch logo`}
            />
          </div>
          <div className={`info-${classTitle}-touch-text`}>
            <p>
              Todo este equipamiento lo ofrecemos también con la posibilidad de
              automatizarlo y controlarlo con un touch panel, permitiendo de esa
              forma un uso amigable y sencillo para el usuario final.
            </p>
          </div>
        </div>
        <BarraSoluciones />
      </div>
    </>
  )
}
